<template>
    <div>
        <!-- <div class="title">{{ title }}</div> -->

        <div class="main">
            <el-row style="margin: auto;width: 100%;border: 5px solid white;padding:2px 2px 2px 2px;">
                <el-col :span="2">
                    <el-button @click="export_note = true" round style="color: #000000;" size="small">Export
                        selected</el-button>
                </el-col>

                <el-col :span="4">
                    <el-tooltip :content="'Text match details : ' + detail_flag" placement="top">
                        <el-switch v-model="detail_flag" active-color="#409eff" inactive-color="" :active-value="true"
                            :inactive-value="false" active-text="ON-TMD" inactive-text="OFF-TMD">
                        </el-switch>
                    </el-tooltip>
                </el-col>

                <el-col :span="4">
                    <el-tooltip :content="'Text match details : ' + showImage_flag" placement="top">
                        <el-switch v-model="showImage_flag" active-color="#409eff" inactive-color=""
                            :active-value="true" :inactive-value="false" active-text="Show-Image"
                            inactive-text="OFF-Image">
                        </el-switch>
                    </el-tooltip>
                </el-col>

                <el-col :span="3" v-if="this.$parent.user == 'admin'">
                    <el-button v-if="this.$parent.user == 'admin'" @click="goAssignee()" round
                        style="color: #000000;width: 90%;" size="small">Mark Assignee</el-button>
                    <div v-else>&nbsp;</div>
                </el-col>

                <el-col :span="3">
                    <el-button @click="close_website_note = true" round style="color: #000000;width: 90%;"
                        size="small">Mark
                        website as false</el-button>
                </el-col>
                <el-col :span="3">
                    <el-button @click="changeSelect('remove')" round style="color: #000000;width: 90%;"
                        size="small">Mark
                        selected as remove</el-button>
                </el-col>
                <el-col :span="3">
                    <el-button @click="changeSelect('match')" round style="color: #000000;width: 90%" size="small">Mark
                        selected as match</el-button>
                </el-col>
                <el-col :span="3">
                    <el-button @click="changeSelect('no_match')" round style="color: #000000;width: 90%"
                        size="small">Mark
                        selected as not match</el-button>
                </el-col>
            </el-row>

            <el-row class="search-main-box">
                <el-row>
                    <el-col :span="3" style="font-size: small">
                        <el-row class="search-type-title">
                            Filter by Company
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.company" multiple collapse-tags class="search-select"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Filter by Company</template>-->
                                <el-option v-for="item in company_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>
                    <el-col :span="2" style="font-size: small">
                        <el-row class="search-type-title">
                            match source
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.source" multiple clearable collapse-tags class="search-select"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Filter by match source</template>-->
                                <el-option v-for="item in source_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>
                    <el-col :span="4" style="font-size: small">
                        <el-row class="search-type-title">
                            Verify status
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.verify" multiple clearable collapse-tags class="search-select"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Verify status</template>-->
                                <el-option v-for="item in verify_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>

                    <el-col :span="4" style="font-size: small">
                        <el-row class="search-type-title">
                            Vddb Title
                        </el-row>
                        <el-row>
                            <el-input placeholder="" v-model="Vddb_Titile_value" class="input-with-select"
                                style="width: 98%;" size="small">
                            </el-input>
                        </el-row>
                    </el-col>


                    <el-col :span="3" style="font-size: small">
                        <el-row class="search-type-title">
                            Text match details
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.tmd" multiple clearable collapse-tags class="search-select"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Text match details</template>-->
                                <el-option v-for="item in tmd_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>
                    <el-col :span="8" style="font-size: small">
                        <el-row class="search-type-title">
                            Input Search
                        </el-row>
                        <el-row>
                            <el-input placeholder="" v-model="s_value" class="input-with-select" style="width: 98%;"
                                size="small">
                                <el-select v-model="s_key" slot="prepend" placeholder="搜索类型" style="width: 7.5rem;"
                                    size="small">
                                    <el-option v-for="item in search_options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-button slot="append" icon="el-icon-search" @click="get_items(1)">Search</el-button> -->
                            </el-input>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3" style="font-size: small">
                        <el-row class="search-type-title">
                            Series image status
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.series_img_status" clearable collapse-tags style="width: 98%;"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Text match details</template>-->
                                <el-option v-for="item in series_img_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>

                    <el-col :span="3" style="font-size: small">
                        <el-row class="search-type-title">
                            Filter by Assignee
                        </el-row>
                        <el-row>
                            <el-select v-model="s_search.assignee" clearable multiple collapse-tags style="width: 98%;"
                                placeholder="ALL" size="small">
                                <!--            <template slot="prefix">Text match details</template>-->
                                <el-option v-for="item in assignee_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                    </el-col>

                    <el-col :span="4" style="font-size: small">
                        <el-row class="search-type-title">
                            Confirm time
                        </el-row>
                        <el-row>
                            <el-date-picker style="width: 98%;" type="daterange" align="right" unlink-panels
                                range-separator="to" start-placeholder="Start" end-placeholder="End"
                                value-format="yyyy-MM-dd" size="small" v-model="confirm_time"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-row>
                    </el-col>

                    <el-col :span="4" style="font-size: small">
                        <el-row class="search-type-title">
                            Score ranger
                        </el-row>
                        <el-row>
                            <el-input placeholder="最小值" v-model="score_min" class="input-with-select"
                                style="width: 40%;display:inline-block;" size="small">
                            </el-input>
                            <el-input placeholder="最大值" v-model="score_max" class="input-with-select"
                                style="width: 40%;display:inline-block;" size="small">
                            </el-input>
                        </el-row>
                    </el-col>

                    <el-col :span="4" style="font-size: small">
                        <el-row class="search-type-title">
                            Created time
                        </el-row>
                        <el-row>
                            <el-date-picker style="width: 98%;" type="daterange" align="right" unlink-panels
                                range-separator="to" start-placeholder="Start" end-placeholder="End"
                                value-format="yyyy-MM-dd" size="small" v-model="created_time"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-row>
                    </el-col>

                    <el-col :span="4">
                        <el-row>
                            &nbsp;
                        </el-row>
                        <el-row>
                            <el-button icon="el-icon-search" @click="get_items(2)" size="small" round
                                style="width: 30%;font-weight: bold;">Apply</el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </el-row>

            <div class="block">
                <el-pagination @size-change="handleSizeChange" layout="total, slot" :page-sizes="[100, 200]"
                    :page-size="s_search.pagesize" :total="page_total">
                    <span style="width: 3rem;">
                        <el-button @click="get_items(-1)" size="mini" icon="el-icon-back"></el-button>
                    </span>
                    <span style="width: 3rem;">
                        <el-button @click="get_items(1)" size="mini" icon="el-icon-right"></el-button>
                    </span>
                    <span style="width: 6rem;color: #606266;">
                        <el-input v-model="s_search.pagesize" :controls="false" :min="12" @change="handleSizeChange"
                            size="mini" style="width: 85%;">
                        </el-input>
                        /p
                    </span>
                </el-pagination>
            </div>

            <el-table ref="p_table" v-loading="loading" :data="items" border class="process-table" fit
                @cell-click="handleCellClick" @selection-change="chooseThis" cell-class-name="not-select-row"
                :row-class-name="rowClass" :default-sort="{ prop: 'vddb_title' }" :cell-style="{ padding: '0px' }"
                header-cell-class-name="process-header" :header-cell-style="{
                    'background-color': '#7f7f7f',
                    'text-align': 'center',
                }">
                <el-table-column prop="company" label="Company" min-width="8%" width="120"
                    align="center"></el-table-column>
                <el-table-column prop="id" label="IMDB picture" min-width="8%" width="300" align="center"
                    v-if="showImage_flag">
                    <template slot-scope="vob">
                        <div v-if="showImage_flag">
                            <a :href="'https://www.imdb.com/title/tt' +
                                vob.row.text_match_details[0].vobile +
                                '/'
                                " target="_blank" v-if="vob.row.text_match_details[0]">
                                <el-image style="width: 300px;" :src="vob.row.text_match_details[0].imdb_cover_url"
                                    @error="loadBackupImage2(vob.row.text_match_details[0])"></el-image>
                            </a>
                            <div v-else>&nbsp;</div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column prop="id" label="Link picture" min-width="8%" width="300" align="center"
                    v-if="showImage_flag">
                    <template slot-scope="vob">
                        <div v-if="showImage_flag">
                            <a :href="vob.row.matched_linking_urls" target="_blank"
                                v-if="vob.row.text_match_details[0]">
                                <el-image style="width: 300px;" :src="vob.row.text_match_details[0].linking_cover_url"
                                    @error="loadBackupImage(vob.row.text_match_details[0])"></el-image>
                            </a>
                            <div v-else>&nbsp;</div>
                        </div>
                    </template>
                    <!-- <a :href="tmd_data.row.matched_linking_urls" target="_blank" v-else-if="vob.row.key=='imdbid'" >
          <el-image
                style="width: 21.25rem;"
                :src="vob.row.linking_url"
                ></el-image>
          </a> -->
                </el-table-column>

                <!-- <el-table-column prop="domain" label="Domain" min-width="10%" align="center"></el-table-column> -->
                <el-table-column prop="vddb_title" label="Vddb_title" min-width="20%" align="center"
                    sortable></el-table-column>
                <!-- <el-table-column prop="match_source" label="Match Source" width="125" min-width="10%" align="center"></el-table-column> -->
                <!-- <el-table-column prop="score" label="Score" width="80" align="center" :formatter="format_data"></el-table-column> -->
                <el-table-column prop="text_match_details" type="index" min-width="30%" width="700" align="center"
                    v-if="this.detail_flag">
                    <template slot="header">
                        <el-row style="border: white;">
                            <el-col :span="24">
                                Text Match Details
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">Meta</el-col>
                            <el-col :span="8">IMDB</el-col>
                            <el-col :span="8">Linking URL</el-col>
                        </el-row>
                    </template>
                    <!-- Text Match Details -->
                    <template v-slot="tmd_data" width="40%">
                        <el-table :data="tmd_data.row.text_match_details" border :show-header="false"
                            :cell-class-name="rowClass1(tmd_data.row)" size="mini" width="100%"
                            :cell-style="{ padding: '0px' }">
                            <!-- :show-header="false" -->
                            <el-table-column prop="key" label="Meta" min-width="10%">
                                <template slot-scope="vob">
                                    <div v-html="vob.row.key"></div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="vobile" label="Vobile" min-width="10%">
                                <template slot-scope="vob">
                                    <div v-if="vob.row.key == 'imdbid'">
                                        <a :href="'https://www.imdb.com/title/tt' + vob.row.vobile + '/'
                                            " target="_blank">{{ vob.row.vobile
                                            }}</a>
                                    </div>
                                    <!-- <a :href="'https://www.imdb.com/title/tt'+vob.row.vobile+'/'" target="_blank" v-if="vob.row.key=='imdbid'" >
                  <el-image
                        style="width: 21.25rem;"
                        :src="'https://lsr.storage.googleapis.com/snapshot/imdb/'+vob.row.vobile.slice(-4,-2)+'/'+vob.row.vobile.slice(-2)+'/'+vob.row.vobile+'.jpg'"
                        ></el-image>
                  </a> -->

                                    <!-- <el-popover placement="left-start" trigger="hover" v-else-if="vob.row.key=='imdbid'">
                    <el-image
                          style="width: 21.25rem;"
                          :src="'https://lsr.storage.googleapis.com/snapshot/imdb/'+vob.row.vobile.slice(-4,-2)+'/'+vob.row.vobile.slice(-2)+'/'+vob.row.vobile+'.jpg'"
                          ></el-image>
                    <el-image
                          style="width: 21.25rem;"
                          :src="vob.row.linking_url"
                          ></el-image>
                    <div slot="reference"></div>
                  </el-popover> -->

                                    <div v-else-if="vob.row.key == 'release_year'">
                                        {{ vob.row.vobile }}
                                    </div>
                                    <el-popover placement="left-start" trigger="hover"
                                        v-else-if="vob.row.key == 'title'">
                                        <!--                    <div >{{vob.row.vobile}}</div>-->
                                        <div style="width: 42.5rem; ">
                                            <div
                                                style="width: 21.25rem; border: #000000;border-style: initial;float: left;">
                                                <!-- <span> also as know as //</span> -->
                                                <div v-html="x" v-for="x in akas_data"></div>
                                            </div>
                                            <!-- <span> series title //</span> -->
                                            <div style="width: 21.25rem;float: left;">
                                                {{ vob.row.linking_url }}
                                            </div>
                                        </div>

                                        <div slot="reference" v-on:mouseenter="get_akas(tmd_data.row.imdbid)">
                                            {{ vob.row.vobile }}
                                        </div>
                                    </el-popover>

                                    <el-popover placement="left-start" trigger="hover" width="200" v-else>
                                        <!--                    <div >{{vob.row.vobile}}</div>-->
                                        <div v-html="vob.row.vobile"></div>
                                        <div slot="reference">
                                            {{ vob.row.vobile.slice(0, 10) }}
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>

                            <el-table-column prop="linking_url" label="Linking URL" min-width="10%">
                                <template slot-scope="vob">
                                    <!-- <el-popover placement="left-start" trigger="click" v-if="vob.row.linking_url.indexOf('http') != -1 ">
                    <img :src="vob.row.linking_url" style="width: 31.25rem;" />
                    <img slot="reference" :src="vob.row.linking_url" height="50px" />
                  </el-popover> -->
                                    <div v-html="vob.row.linking_url" v-if="vob.row.key == 'title' || vob.row.key == 'release_year'
                                    "></div>
                                    <div v-else-if="vob.row.key == 'imdbid'">
                                        <a :href="tmd_data.row.matched_linking_urls" target="_blank">{{ vob.row.vobile
                                            }}</a>
                                    </div>
                                    <!-- <a :href="tmd_data.row.matched_linking_urls" target="_blank" v-else-if="vob.row.key=='imdbid'" >
                  <el-image
                        style="width: 21.25rem;"
                        :src="vob.row.linking_url"
                        ></el-image>
                  </a> -->

                                    <el-popover placement="left-start" trigger="hover" width="200" v-else>
                                        <div v-html="vob.row.vobile"></div>
                                        <hr />
                                        <div v-html="vob.row.linking_url"></div>
                                        <div slot="reference" v-html="vob.row.linking_url.slice(0, 8)"></div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>

                <el-table-column type="selection" min-width="4%" width="50" prop="id" align="center"></el-table-column>

                <el-table-column prop="matched_linking_urls" label="Matched Linking URLs" min-width="20%" width="400"
                    align="left"></el-table-column>
                <el-table-column label="Confirm" min-width="6%" width="100" align="center" type="index">
                    <template v-slot="cf"
                        style="display: flex;align-items: center;justify-content: center;width: auto;flex-direction: column;">
                        <button @click="
                            cf.row.verify_status != 'match'
                                ? changeOne(cf.row, 'match')
                                : ''
                            " :class="cf.row.verify_status == 'match' ? 'match' : 'not-match'">
                            Match
                        </button>
                        <button @click="
                            cf.row.verify_status != 'no_match'
                                ? changeOne(cf.row, 'no_match')
                                : ''
                            " :class="cf.row.verify_status == 'no_match' ? 'match' : 'not-match'
                                ">
                            Not Match
                        </button>
                    </template>
                </el-table-column>
                <el-table-column prop="verify_status" label="Verify Status" min-width="10%" width="140"
                    align="center"></el-table-column>
                <el-table-column prop="assignee" label="Assignee" min-width="10%" width="130"
                    align="center"></el-table-column>
                <el-table-column prop="score" label="Score" min-width="10%" width="130"
                    align="center"></el-table-column>
            </el-table>

            <!-- <el-dialog title="请确认是否修改？" :visible.sync="confirm_note" :modal=false :show-close=false width="30%" center>
        <span>Title : {{this.tab_obj.vddb_title}}</span><br />
        <span>Match Source : {{this.tab_obj.match_source}}</span><br />
        <span>Matched Linking URLs : {{this.tab_obj.matched_linking_urls}}</span><br />
        <span>Score : {{this.tab_obj.score}}</span><br />
        <span>Verify Status : {{this.tab_obj.verify_status}}</span><br /><br />
        <span>目标 Verify Status : {{this.confirm_match_data}}</span><br />
        <span slot='footer' class="dialog-footer">
          <el-button @click="confirm_note=false">取消</el-button>
          <el-button type="primary" @click="updataConfirm(1)">确定</el-button>
        </span>
      </el-dialog> -->

            <el-dialog title="" :visible.sync="confirm_select_note" :modal="false" :show-close="false" width="30%"
                center>
                <span v-if="checkList.length != 0">请确认修改信息<br /><br /></span>
                <span v-for="tab in checkList">id: {{ tab.id }} ,scorce:{{ tab.score }}<br /></span><br />
                <span v-if="checkList.length != 0">目标 Verify Status : {{ this.confirm_match_data }}</span><br />
                <span v-if="checkList.length == 0">You have not selected any URLs !</span><br />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirm_select_note = false" v-if="checkList.length != 0">Cancel</el-button>
                    <el-button @click="confirm_select_note = false" v-if="checkList.length == 0">OK</el-button>
                    <el-button type="primary" @click="updataConfirm(2)" v-if="checkList.length != 0">YES</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="export_note" :modal="false" :show-close="false" width="30%" center>
                <span v-if="checkList.length != 0">请确认导出信息<br /><br /></span>
                <span v-if="checkList.length == 0">You have not selected any One !</span><br />
                <span v-for="tab in checkList">id: {{ tab.id }} ,scorce:{{ tab.score }}<br /></span><br />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="export_note = false" v-if="checkList.length != 0">取消</el-button>
                    <el-button type="primary" @click="exportExcel()" v-if="checkList.length != 0">确定</el-button>
                    <el-button type="primary" @click="export_note = false" v-if="checkList.length == 0">OK</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="assignee_note" :modal="false" :show-close="false" width="30%" center>
                <span v-if="checkList.length != 0">请选择分配用户<br /><br /></span>
                <span v-if="checkList.length == 0">You have not selected any One !</span><br />
                <el-select v-if="checkList.length != 0" v-model="allocat_assignee" collapse-tags style="width: 98%;"
                    placeholder="Not_assigned" size="small">
                    <el-option v-for="item in assignee_options" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="assignee_note = false" v-if="checkList.length != 0">取消</el-button>
                    <el-button type="primary" @click="changeAssignee()" v-if="checkList.length != 0">确定</el-button>
                    <el-button type="primary" @click="assignee_note = false" v-if="checkList.length == 0">OK</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="close_website_note" :modal="false" :show-close="false" width="30%" center>
                <span v-if="checkList.length != 0">请确认<br /><br /></span>
                <span v-if="checkList.length == 0">You have not selected any One !</span><br />
                <span v-for="tab in checkList">id: {{ tab.id }} ,link:{{ tab.matched_linking_urls }}<br /></span><br />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="close_website_note = false" v-if="checkList.length != 0">取消</el-button>
                    <el-button type="primary" @click="closeWebsite()" v-if="checkList.length != 0">确定</el-button>
                    <el-button type="primary" @click="close_website_note = false"
                        v-if="checkList.length == 0">OK</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: "In_process",
    data() {
        return {
            // user:this.$route.query.username,
            user: localStorage.getItem("user"),
            loading: false, //控制表格loading状态
            title: "In-process Mapping Table",
            checkList: [], //选择了的数据
            items: [], //需要渲染的数据
            resData: [], //服务器返回的数据
            detail_flag: true, //控制TMD展开收缩的
            showImage_flag: true, //控制TMD展开收缩的
            confirm_note: false, //跳出提示框是否改变match状态的
            confirm_select_note: false, //跳出提示框是否改变match状态的
            export_note: false, //跳出提示框是否改变导出状态的
            assignee_note: false, //跳出提示框分配assignee人员
            close_website_note: false, //关闭网站得提示框
            allocat_assignee: "not_assigned",
            confirm_match_data: "", //保存要切换到哪个verify状态的信息 1.verified_match 2.not_verified_match
            tab_obj: [], //单选match用来存选中对象的
            //search
            page_prev: "",
            page_next: "",
            page_total: 0,
            s_key: "",
            s_value: "",
            Vddb_Titile_value: "",
            akas_data: "",
            score_min: null,
            score_max: null,
                s_search: {
                company: [1746, 1739, 1687, 1570, 1629, 100, 8, 14, 20, 1296, 1447, 1591, 1355],
                source: [],
                verify: ["pending_match"],
                tmd: [],
                pagesize: 50,
                assignee: ["not_assigned"],
                series_img_status: "",
                cursor: "",
                domain_is_enabled: "true",
            },
            company_options: [
                { value: 1746, label: "Sky" },
                { value: 1739, label: "Tooley Ent" },
                { value: 1687, label: "Globo" },
                { value: 1651, label: "CPCC-haiwai" },
                { value: 1570, label: "Apple" },
                { value: 1355, label: "AE_Media" },
                { value: 55, label: "Summit Entertainment" },
                { value: 1629, label: "beIN" },
                { value: 8, label: "WarnerBros" },
                { value: 1296, label: "Paramount" },
                { value: 14, label: "Viacom" },
                { value: 1447, label: "Netflix2" },
                { value: 20, label: "CBS" },
                { value: 1591, label: "Quibi" },
                { value: 4, label: "Disney" },
                { value: 28, label: "Rainbow Media" },
                { value: 1396, label: "discovery_prod" },
                { value: 1390, label: "HBOinc" },
                { value: 99, label: "Relativity" },
                { value: 110, label: "Toho" },
                { value: 1496, label: "Amazon" },
                { value: 1533, label: "Annapurna" },
                { value: 74, label: "VobileJapan" },
                { value: 77, label: "Toei Animation" },
                { value: 100, label: "Lionsgate" },
                { value: 13, label: "NBCU" },
                { value: 1434, label: "Studio Chizu" },
                { value: 1356, label: "OW_Network" },
                { value: 2, label: "Tracker Demonstration" },
                { value: 1370, label: "Vobile Singapore Demo" },
                { value: 11, label: "MPAA" },
                { value: 1452, label: "Scripps" },
                { value: 1439, label: "STX" },
                { value: 1565, label: "endemolshine" },
                { value: 90, label: "Toei" },
                { value: 1596, label: "WorldWrestlingEnt" },
                { value: 1102, label: "Youtube" },
                { value: 1498, label: "Turner_CN" },
                { value: 1365, label: "liveviewing" },
                { value: 65, label: "Starz" },
                { value: 1325, label: "omnia media" },
                { value: 114, label: "Presentcast" },
                { value: 1555, label: "Facebook Admin" },
                { value: 1455, label: "Miramax" },
                { value: 1524, label: "Aviron" },
                { value: 18, label: "Sony" },
                { value: 1364, label: "NipponTV" },
                { value: 1393, label: "APM" },
                { value: 84, label: "KodanshaLtd" },
                // { value: 1355, label: "AE_Media" },
                { value: 1369, label: "Netflix" },
                { value: 23, label: "Warner Music Group" },
                { value: 1399, label: "CJE&M" },
                { value: 1258, label: "FujiTV" },
                { value: 1450, label: "FoxLatAM" },
                { value: 87, label: "CPCC" },
                { value: 98, label: "NHK" },
                { value: 1438, label: "Discovery_One" },
                { value: 1406, label: "Dick Clark Productions" },
                { value: 1384, label: "T-JOY" },
                { value: 1633, label: "Youku" },
            ],
            confirm_time: ["", ""],
            created_time: ["", ""],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "last day",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "last week",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "last month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "last 3 months",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            assignee_options: [
                {
                    value: "not_assigned",
                    label: "not_assigned",
                },
                {
                    value: "Alice",
                    label: "Alice",
                },
                {
                    value: "Bella",
                    label: "Bella",
                },
                {
                    value: "Cyrus",
                    label: "Cyrus",
                },
                {
                    value: "Diana",
                    label: "Diana",
                },
                {
                    value: "Eva",
                    label: "Eva",
                },
                {
                    value: "Fiona",
                    label: "Fiona",
                },
                {
                    value: "Gina",
                    label: "Gina",
                },
                {
                    value: "Helen",
                    label: "Helen",
                },
                {
                    value: "Irene",
                    label: "Irene",
                },
                {
                    value: "Jana",
                    label: "Jana",
                },
                {
                    value: "Karis",
                    label: "Karis",
                },
                {
                    value: "Lila",
                    label: "Lila",
                },
                {
                    value: "Maura",
                    label: "Maura",
                },
                {
                    value: "Nikki",
                    label: "Nikki",
                },
                {
                    value: "Oreo",
                    label: "Oreo",
                },
                {
                    value: "Paula",
                    label: "Paula",
                },
                {
                    value: "Q",
                    label: "Q",
                },
                {
                    value: "Rose",
                    label: "Rose",
                },
                {
                    value: "Sofia",
                    label: "Sofia",
                },
                {
                    value: "Tony",
                    label: "Tony",
                },
            ],
            source_options: [
                {
                    value: "Manual",
                    label: "Manual",
                },
                {
                    value: "vDNA",
                    label: "vDNA",
                },
                {
                    value: "text-match",
                    label: "Text-match",
                },
            ],
            verify_options: [
                {
                    value: "pending_match", //侵权状态
                    label: "pending_match 等待人工审核",
                },
                {
                    value: "match",
                    label: "match 人工审核匹配",
                },
                {
                    value: "no_match",
                    label: "no_match 人工审核不匹配",
                },
                {
                    value: "llm_match",
                    label: "llm_match LLM模型匹配",
                },
                {
                    value: "llm_no_match",
                    label: "llm_no_match LLM模型不匹配",
                },
                {
                    value: "llm_cannot",
                    label: "llm_cannot LLM模型无法判断",
                },
                {
                    value: "pending_no_match",
                    label: "pending_no_match 系统不匹配，待确认",
                },
                {
                    value: "manual_match",
                    label: "manual_match 人工确认匹配",
                },
                {
                    value: "manual_no_match",
                    label: "manual_no_match 人工确认不匹配",
                },
                {
                    value: "pending",
                    label: "Pending 等待系统匹配",
                },
                {
                    value: "close",
                    label: "Close 无法访问",
                },
                {
                    value: "remove",
                    label: "Remove 资源已移除",
                },
            ],
            tmd_options: [
                {
                    value: "title", //tmd比对
                    label: "Title",
                },
                {
                    value: "imdbid", //tmd比对
                    label: "IMDB id",
                },
                {
                    value: "director", //tmd比对
                    label: "Director",
                },
                {
                    value: "release_year", //tmd比对
                    label: "Release",
                },
                {
                    value: "country", //tmd比对
                    label: "Country",
                },
                {
                    value: "cast", //tmd比对
                    label: "Cast",
                },
            ],
            search_options: [
                {
                    value: "domain", //搜索类型
                    label: "Domain",
                },
                {
                    value: "linking_urls",
                    label: "Linking URL",
                },
                // {
                //   value: "title",
                //   label: "Vddb_title",
                // },
                {
                    value: "website_id",
                    label: "Website id",
                },
                {
                    value: "",
                    label: "N/A",
                },
            ],
            series_img_options: [
                {
                    value: "",
                    label: "ALL",
                },
                {
                    value: "true",
                    label: "True",
                },
                {
                    value: "false",
                    label: "False",
                },
            ],
        };
    },
    //   created(params) {
    //     this.get_items(2);
    //   },
    methods: {
        handleCellClick(row, column, cell, event) {
            // 判断是否点击的是表格中的选择列
            if (column.type === 'selection') {

                var tag_ids = new Array();
                for (let i = 0; i < this.checkList.length; i++) {
                    tag_ids.push(this.checkList[i].id);
                }
                if (tag_ids.includes(row.id)) {
                    this.$refs.p_table.toggleRowSelection(row, false);
                } else {
                    this.$refs.p_table.toggleRowSelection(row, true);
                }

            }
        },
        goAssignee: function () {
            this.assignee_note = true;
        },
        changeAssignee: function () {
            // console.log(this.checkList)
            var tag_ids = new Array();
            for (let i = 0; i < this.checkList.length; i++) {
                tag_ids.push(this.checkList[i].id);
            }
            var that = this;
            that.user = localStorage.getItem("user");
            this.$axios({
                method: "post",
                url: "api/assignee/",
                data: {
                    ids: tag_ids,
                    assignee: that.allocat_assignee,
                    manager: localStorage.getItem("user"),
                },
            }).then((res) => {
                if (res.data.code == 0) {
                    that.assignee_note = false;
                    alert(res.data.message);
                    for (let i = 0; i < that.checkList.length; i++) {
                        that.checkList[i].assignee = that.allocat_assignee;
                    }
                }
            });
            that.assignee_note = false;
        },
        closeWebsite: function () {
            // console.log(this.checkList)
            var tag_ids = new Array();
            for (let i = 0; i < this.checkList.length; i++) {
                tag_ids.push(this.checkList[i].id);
            }
            var that = this;
            this.$axios({
                method: "post",
                url: "api/close_website/",
                data: {
                    ids: tag_ids,
                },
            }).then((res) => {
                if (res.data.code == 0) {
                    that.close_website_note = false;
                    that.$message.success("Success");
                } else {
                    that.close_website_note = false;
                    that.$message.error(res.data.msg);
                }
            });
            that.assignee_note = false;
        },
        handleSizeChange: function (val) {
            this.s_search.pagesize = val;
            this.get_items(2);
        },
        get_total: function (path) {
            this.$axios.get("/api/search_total/" + path).then((response) => {
                this.page_total = response.data.total;
            });
        },
        get_items: function (page) {
            // let start_time = new Date().getTime()
            // console.log(start_time)
            this.loading = true;
            // console.log(page)
            if (page == -1) {
                this.s_search.cursor = this.page_prev;
            }
            if (page == 1) {
                this.s_search.cursor = this.page_next;
            }
            if (page == 2) {
                this.s_search.cursor = "";
            }
            let path = "";
            let keys = Object.keys(this.s_search);
            keys.sort();

            for (let i = 0; i < keys.length; i++) {
                let s = keys[i];
                path += (0 == i ? "?" : "&") + s + "=" + this.s_search[s];
            }
            path = path + "&" + this.s_key + "=" + this.s_value;

            try {
                if (this.Vddb_Titile_value) {

                    path = path + "&" + "title" + "=" + this.Vddb_Titile_value;
                }
                else {
                    console.log('Vddb_Titile_value is', this.Vddb_Titile_value)
                }
            } catch (e) {
                console.log('报错了')
            }

            try {
                if (this.confirm_time[0]) {
                    path = path + "&" + "confirm_start" + "=" + this.confirm_time[0];
                }
            } catch (e) {
                //TODO handle the exception
            }
            try {
                if (this.confirm_time[1]) {
                    path = path + "&" + "confirm_end" + "=" + this.confirm_time[1];
                }
            } catch (e) { }
            try {
                if (this.created_time[0]) {
                    path = path + "&" + "created_start" + "=" + this.created_time[0];
                }
            } catch (e) {
                //TODO handle the exception
            }
            try {
                if (this.created_time[1]) {
                    path = path + "&" + "created_end" + "=" + this.created_time[1];
                }
            } catch (e) { }
            try {
                if (this.score_min !== null) {
                    path = path + "&" + "score_min" + "=" + this.score_min;
                }
            } catch (e) { }
            try {
                if (this.score_max !== null) {
                    path = path + "&" + "score_max" + "=" + this.score_max;
                }
            } catch (e) { }
            // console.log(path)
            this.$axios.get("/api/in_process/" + path).then((response) => {
                this.resData = response.data;
                this.items = this.resData.results;
                this.page_next = this.resData.next;
                this.page_prev = this.resData.previous;
                let reg = /cursor=([a-zA-Z0-9=%]+)&/;
                if (this.page_next != null) {
                    let a = reg.exec(this.page_next);
                    this.page_next = a[1];
                    // console.log(this.page_next)
                } else {
                    this.page_next = "";
                }
                try {
                    let a = reg.exec(this.page_prev);
                    this.page_prev = a[1];
                } catch (e) {
                    this.page_prev = "";
                }
                this.loading = false;
            });
            if (page == 2) {
                this.page_total = 0;
                this.get_total(path);
            }
        },
        exportExcel: function () {
            //可参考冬奥会前端的导出excel,使用的vue-json-excel
            let path = "?id=";
            for (let i = 0; i < this.checkList.length; i++) {
                path += (0 == i ? "" : ",") + this.checkList[i].id;
            }
            // console.log(path)
            // this.$axios.get('/api/in_process/excel/'+path)
            this.$axios({
                method: "get",
                url: "/api/in_process/excel/" + path,
                responseType: "arraybuffer",
            }).then((res) => {
                if (res.status == 200) {
                    let blob = new Blob([res.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                        //word文档为application/msword,pdf文档为application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    let link = document.createElement("a");
                    let fname = `In_Process`; //下载文件的名字
                    link.href = objectUrl;
                    link.setAttribute("download", fname);
                    document.body.appendChild(link);
                    link.click();
                } else {
                    this.$message({
                        type: "error",
                        message: "导出失败",
                    });
                }
            });
            this.export_note = false;
        },
        chooseThis: function (val) {
            this.checkList = val;
        },
        loadBackupImage(textMatchDetails) {
            // textMatchDetails.linking_url = textMatchDetails.linking_cover_url;
            textMatchDetails.linking_cover_url = textMatchDetails.linking_url;
        },
        loadBackupImage2(textMatchDetails) {
            // textMatchDetails.linking_url = textMatchDetails.linking_cover_url;
            textMatchDetails.imdb_cover_url = textMatchDetails.imdb_snapshot_url;
        },
        changeOne: function (a, b) {
            this.tab_obj = a;
            this.confirm_match_data = b;
            // this.confirm_note = true
            this.updataConfirm(1);
        },
        changeSelect: function (status) {
            this.confirm_match_data = status;
            // console.log(this.checkList)
            this.confirm_select_note = true;
        },
        updataConfirm: function (flag) {
            var that = this;
            let id_list = [];
            Array.prototype.indexOf = function (val) {
                for (var i = 0; i < this.length; i++) {
                    if (this[i] == val) return i;
                }
                return -1;
            };
            Array.prototype.remove = function (val) {
                var index = this.indexOf(val);
                if (index > -1) {
                    this.splice(index, 1);
                }
            };
            if (flag == 1) {
                id_list[0] = that.tab_obj.id;
                this.$axios({
                    method: "POST",
                    url: "/api/confirm/",
                    data: {
                        id: id_list,
                        status: that.confirm_match_data,
                        assignee: localStorage.getItem("user"),
                        mode: flag,
                    },
                }).then((response) => {
                    // alert(response.data.message)
                    if (0 == response.data.code) {
                        that.tab_obj.verify_status = that.confirm_match_data;
                        that.items.remove(that.tab_obj);
                        this.checkItems();
                    } else {
                        alert(response.data.message);
                    }
                });
                that.confirm_note = false;
            } else {
                for (let i = 0; i < that.checkList.length; i++) {
                    id_list[i] = that.checkList[i].id;
                }
                this.$axios({
                    method: "POST",
                    url: "/api/confirm/",
                    data: {
                        id: id_list,
                        status: that.confirm_match_data,
                        assignee: localStorage.getItem("user"),
                        mode: flag,
                    },
                }).then((response) => {
                    if (0 == response.data.code) {
                        for (let i = 0; i < that.checkList.length; i++) {
                            that.checkList[i].verify_status = that.confirm_match_data;
                            // that.checkList.remove(that.checkList[i])
                            // console.log(that.checkList[i])
                            that.items.remove(that.checkList[i]);
                            // console.log(that.items.length)
                        }
                        // that.checkList = []
                        that.$refs.p_table.clearSelection();
                        this.checkItems();
                    }
                });
                this.confirm_select_note = false;
            }
        },
        checkItems: function () {
            if (this.items.length == 0) {
                this.get_items(0);
            }
        },
        format_data: function (row, column) {
            let pr = column.property;
            if (row[pr]) {
                return row[pr];
            } else {
                return "N/A";
            }
        },
        get_akas: function (imdbid) {
            let that = this;
            // console.log(imdbid)
            this.$axios({
                method: "GET",
                url: "/api/akas/?id=" + imdbid,
            }).then((response) => {
                // alert(response.data.message)
                if (0 == response.data.code) {
                    // let akas_dic = response.data.akas
                    // let akas_str = ''
                    // for(let key in akas_dic){
                    //   let akas_title =  akas_dic[key]
                    //   akas_str += key + ':' + akas_title + '\n'
                    // }

                    // this.akas_data = akas_str
                    that.akas_data = response.data.akas;
                } else {
                    // alert(response.data.message)
                }
            });
        },

        getTmdSum: function (dic) {
            let resSum = 0;
            for (let i in dic) {
                resSum++;
            }
            return resSum;
        },

        rowClass: function ({ row, rowIndex }) {
            if (this.checkList.includes(row)) {
                return "slecledRow";
            } else {
                return "";
            }
        },
        rowClass1: function (row) {
            if (this.checkList.includes(row)) {
                return "slecledRow tmd-row";
            } else {
                return "tmd-row";
            }
        },
    },
};
</script>

<style>
.el-table .slecledRow {
    background-color: aquamarine;
}

.main {
    text-align: center;
    /* background-color: white; */
}

.match {
    width: 78px;
    height: auto;
    display: block;
    text-align: center;
    padding: 4px 5px;
    white-space: nowrap;

    /* width: 4.8rem;
  height: 1.5rem; */
    font-weight: bold;
    color: #409eff;
    border: 0;
    outline: #fc0107;
    border-radius: 0.4rem;
    /*box-shadow: 0.125rem 0rem 0rem #000000;*/
    background-color: white;
}

.not-match {
    width: 78px;
    height: auto;
    display: block;
    text-align: center;
    padding: 4px 5px;
    white-space: nowrap;

    /* width: 4.8rem;
  height: 1.5rem; */
    font-weight: bold;
    /* white-space: pre; */
    border: 0;
    outline: #fc0107;
    border-radius: 0.4rem;
    box-shadow: 0.125rem 0rem 0rem #000000;
    background-color: #409eff;
}

.not-match:hover {
    background-color: #f56c56;
    color: black;
    font-weight: 100;
    box-shadow: 0.225rem 0rem 0rem #21ff06;
    cursor: pointer;
}

.el-row {
    width: 100%;
}

em {
    background-color: greenyellow;
}

en {
    background-color: pink;
}

.search-select {
    width: 98%;
}

.not-select-row {
    border-bottom: 1px solid #7f7f7f;
    border-top: 1px solid #7f7f7f;
    padding: 0rem;
}

.tmd-row {
    /* border-bottom: 1px solid #7F7F7F; */
    border-top: 1px solid #7f7f7f;
    padding: 0rem;
}

.process-table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    padding: 0rem;
}

.process-header {
    font-weight: bold;
    color: #ffffff;
}

.search-main-box {
    background-color: #7f7f7f;
    width: 100%;
    border: 5px solid white;
    padding: 10px 10px 10px 10px;
}

.search-type-title {
    text-align: left;
    font-weight: bold;
    color: #ffffff;
}

.box {
    position: relative;
    overflow: hidden;
    width: 600px;
    height: 420px;
    margin: 0 auto;
    border: 1px solid black;
}

iframe {
    position: absolute;
    transform: scale(0.4);
    left: -480px;
    top: -310px;
}
</style>



// WEBPACK FOOTER //
// src/components/in_process.vue